export const sidoList = [
  { text: "순환계의약품", value: 1 },
  { text: "비타민제", value: 2 },
];

export const matchingStatusOptions = [
  { value: "", text: "전체선택" },
  { value: "PENDING", text: "승인 대기" },
  { value: "APPROVED", text: "승인 완료" },
  { value: "REJECT", text: "승인 거절" },
];

export const napMatchingStatusOptions = [
  { value: "", text: "전체선택" },
  { value: "PENDING", text: "승인 대기" },
  { value: "APPROVED", text: "승인 완료" },
];

export const matchingStatusOptionsNotAll = [
  { value: "PENDING", text: "승인 대기" },
  { value: "APPROVED", text: "승인 완료" },
  { value: "REJECT", text: "승인 거절" },
];

export const ageFriendlyIndustry = [
  {
    value: 1,
    name: "고령친화의약품산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
      { text: "근골격계의약품", value: 3 },
      { text: "당뇨병치료제", value: 4 },
      { text: "자양강장변질제", value: 5 },
      { text: "신경계의약품", value: 6 },
      { text: "소화계의약품", value: 7 },
      { text: "항생물질제제", value: 8 },
      { text: "감각기관용의약품", value: 9 },
      { text: "비뇨생식기 및 항문용의약품", value: 10 },
      { text: "호흡계의약품", value: 11 },
      { text: "호르몬제제", value: 12 },
      { text: "종양용의약품", value: 13 },
      { text: "안과용제", value: 14 },
      { text: "대사성의약품", value: 15 },
      { text: "해열·진통·소염제", value: 16 },
    ],
  },
  {
    value: 2,
    name: "고령친화의료기기산업",
    sectors: [
      { text: "재활기기", value: 1 },
      { text: "진단기기", value: 2 },
      { text: "치과기기", value: 3 },
      { text: "수술/치료기기", value: 4 },
      { text: "치료재료", value: 5 },
      { text: "의료용품", value: 6 },
    ],
  },
  {
    value: 3,
    name: "고령친화식품산업",
    sectors: [
      { text: "건강기능식품", value: 1 },
      { text: "특수용도식품", value: 2 },
      { text: "고령친화식품", value: 3 },
    ],
  },
  {
    value: 4,
    name: "고령친화화장품산업",
    sectors: [
      { text: "기능성화장품", value: 1 },
      { text: "기초화장제품", value: 2 },
      { text: "눈화장제품", value: 3 },
      { text: "두발제품", value: 4 },
      { text: "면도제품", value: 5 },
      { text: "방향제품", value: 6 },
      { text: "목욕제품", value: 7 },
      { text: "색조화장제품", value: 8 },
      { text: "손발톱제품", value: 9 },
      { text: "염모제품", value: 10 },
      { text: "인체세정제품", value: 11 },
      { text: "체취방지제품", value: 12 },
    ],
  },
  {
    value: 5,
    name: "고령친화용품산업",
    sectors: [
      { text: "개인건강·의료용품", value: 1 },
      { text: "기능저하예방용품", value: 2 },
      { text: "이동기기", value: 3 },
      { text: "목욕용품", value: 4 },
      { text: "배변용품", value: 5 },
      { text: "침구용품", value: 6 },
      { text: "가사용품", value: 7 },
      { text: "주거설비용품", value: 8 },
      { text: "정보통신기기", value: 9 },
      { text: "여가용품", value: 10 },
    ],
  },
  {
    value: 6,
    name: "고령친화요양산업",
    sectors: [
      { text: "예방지원서비스", value: 1 },
      { text: "시설요양서비스", value: 2 },
      { text: "재가요양서비스", value: 3 },
    ],
  },
  {
    value: 7,
    name: "고령친화금융산업",
    sectors: [
      { text: "건강리스크", value: 1 },
      { text: "생존리스크", value: 2 },
      { text: "재무리스크", value: 3 },
    ],
  },
  {
    value: 8,
    name: "고령친화주거산업",
    sectors: [
      { text: "주택 개보수", value: 1 },
      { text: "고령자 주택 공급", value: 2 },
    ],
  },
  {
    value: 9,
    name: "고령친화여가산업",
    sectors: [
      { text: "문화산업", value: 1 },
      { text: "여행·레저산업", value: 2 },
      { text: "스포츠 산업", value: 3 },
      { text: "기타 여가·문화산업", value: 4 },
    ],
  },
  {
    value: 10,
    name: "이동 교통서비스산업",
    sectors: [
      { text: "이동 산업", value: 1 },
      { text: "교통 산업", value: 2 },
      { text: "정보통신업", value: 3 },
    ],
  },
  {
    value: 11,
    name: "Age Tech 산업",
    sectors: [
      { text: "힐링산업", value: 1 }
    ],
  },
  { value: 12, name: "기타산업", sectors: [
    { text: "기타산업", value: 1 },
    ], 
  },
];

export const hopeActivity = [
  { name: "마케팅, 브랜드, 판로, 유통", value: "1" },
  { name: "비즈니스 컨설팅, 디자인, 설계", value: "2" },
  { name: "기술 이전", value: "3" },
  { name: "B2B 거래(제품 서비스 판매 or 구매)", value: "4" },
  { name: "공동 연구개발(R&D)", value: "5" },
  { name: "투자, 자금 조달", value: "6" },
  { name: "생산, 제조", value: "7" },
  { name: "비즈니스 파트너쉽 구축", value: "8" },
  { name: "해외판로개척, 수출, 글로벌 협력", value: "9" },
  { name: "아웃소싱(외주)", value: "10" },
  { name: "실증 및 임상평가", value: "11" },
  { name: "취업 및 창업 컨설팅", value: "12" },
  { name: "연구 기기 대여", value: "13" },
  { name: "교육, 멘토링", value: "14" },
  { name: "기타", value: "15" },
];

export const relevantList = [
  {
    name: "고령친화의약품산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 1,
  },
  {
    name: "고령친화의료기기산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 2,
  },
  {
    name: "고령친화식품산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 3,
  },
  {
    name: "고령친화화장품산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 4,
  },
  {
    name: "고령친화용품산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 5,
  },
  {
    name: "고령친화요양산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 6,
  },
  {
    name: "고령친화금융산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 7,
  },
  {
    name: "고령친화주거산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 8,
  },
  {
    name: "고령친화여가산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 9,
  },
  {
    name: "이동 교통서비스산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 10,
  },
  {
    name: "힐링산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 11,
  },
  {
    name: "Age Tech 산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 12,
  },
  {
    name: "기타산업",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 13,
  },
];

export const matchmakingList = [
  {
    name: "마케팅, 브랜드, 판로, 유통",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 1,
  },
  {
    name: "비즈니스 컨설팅, 디자인, 설계",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 2,
  },
  {
    name: "교육, 멘토링",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 3,
  },
  {
    name: "기술 이전",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 4,
  },
  {
    name: "B2B 거래(제품 서비스 판매 or 구매)",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 5,
  },
  {
    name: "공동 연구개발(R&D)",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 6,
  },
  {
    name: "투자, 자금 조달",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 7,
  },
  {
    name: "생산, 제조",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 8,
  },
  {
    name: "비즈니스 파트너쉽 구축",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 9,
  },
  {
    name: "해외판로개척, 수출, 글로벌 협력",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 10,
  },
  {
    name: "아웃소싱(외주)",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 11,
  },
  {
    name: "실증 및 임상평가",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 12,
  },
  {
    name: "취업 및 창업 컨설팅",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 13,
  },
  {
    name: "연구 기기 대여",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 14,
  },
  {
    name: "기타",
    sectors: [
      { text: "순환계의약품", value: 1 },
      { text: "비타민제", value: 2 },
    ],
    value: 15,
  },
];

export const napStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECT: "REJECT",
  DELETED: "DELETED",
};

export const directStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECT: "REJECT",
  DELETED: "DELETED",
};

export const userClassification = [
  { text: "학생", value: "1", color: "#B7CEA4" },
  { text: "연구원", value: "2", color: "#D3ACAC" },
  { text: "기업인", value: "3", color: "#AACFD1" },
];

export const keyStorage = {
  matchingStatus: 'matchingStatusStore',
  showMatchingNoti: 'showMatchingNoti',
}
